export default "__VITE_ASSET__g$CxkEjJ__"